import { InjectionToken } from '@angular/core';
import { environment } from '../../../environments/environment';

// Configuración de la app inyectable en cualquier componente/servicio (patrón del conductor).
export interface AppConfig {
  readonly production: boolean;
  readonly appName: string;
  /** Base del servicio de autenticación. En desarrollo se enruta por el proxy Angular. */
  readonly authApiBaseUrl: string;
  /**
   * Base del servicio de viajes (`utx-core-trip-service`).
   * En desarrollo se enruta por el proxy Angular hacia el puerto 2031.
   */
  readonly tripApiBaseUrl: string;
  /**
   * Base del servicio de seguimiento (`utx-core-tracking-service`), sobre el que
   * se abre el WebSocket SockJS/STOMP en `/ws/connect`.
   */
  readonly trackingApiBaseUrl: string;
  /** Base del catálogo administrativo de categorías de vehículo. */
  readonly adminApiBaseUrl: string;
  /** Base del servicio de soporte (`utx-ext-support-service`): evaluaciones y tickets. */
  readonly supportApiBaseUrl: string;
  /** IDs públicos necesarios por los SDKs web de proveedores sociales. */
  readonly socialAuth: {
    readonly googleClientId: string;
    readonly facebookAppId: string;
  };
  readonly googleMaps: {
    readonly apiKey: string;
  };
  /**
   * Tiles de OpenStreetMap para el mapa de la traza del viaje (Leaflet), igual
   * que en la app del conductor.
   *
   * `tileUrl` es una plantilla `{z}/{x}/{y}`; si el proveedor exige una llave,
   * va incrustada en la URL (`?key=…`), que es como la piden casi todos. Vacío
   * significa "sin proveedor": el mapa se degrada a un aviso en vez de pedir
   * tiles indebidamente.
   *
   * **`attribution` no es decorativo**: la licencia ODbL de OpenStreetMap obliga
   * a dar crédito, y los proveedores de tiles suelen exigir el suyo además. No
   * lo vacíes.
   */
  readonly osmTiles: {
    readonly tileUrl: string;
    readonly attribution: string;
    readonly maxZoom: number;
  };
}

export const APP_CONFIG = new InjectionToken<AppConfig>('APP_CONFIG', {
  providedIn: 'root',
  factory: (): AppConfig => environment,
});
